import { useState } from 'react';

const SOCIAL_LINKS = [
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/waihsuen/' },
  { label: 'Behance', url: 'https://www.behance.net/waihsuen' },
  { label: 'Medium', url: 'https://medium.com/@waihsuen' },
  { label: 'Unsplash', url: 'https://unsplash.com/@waihsuen' },
  { label: 'Vimeo', url: 'https://vimeo.com/waihsuen' },
  { label: 'GitHub', url: 'https://github.com/waihsuen' }
];

function Resume() {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText("chanwaihsuen@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ marginBottom: '4rem' }}>
      <section>
        <p className="resume-description">
          I enjoy product building and strategy, understanding the use of technology and engineering, identifying technology trends,
          creative advertising and branding.
        </p>
        <p className="resume-description">
          Over the span of my career, I've developed and launched successful mobile apps, websites and digital installations. While a
          <strong> software engineer by training</strong>, I am also an experimenter and a creative. My current focus is in the use of technology in product
          innovation.
        </p>
        <p className="resume-description">
          I have worked on projects with clients such as <strong>Levi's, Chupa Chups, Hasbro, Yahoo, MINI, Axe, Google, F&amp;N and Nike</strong>.
        </p>
        <p className="resume-description">
          I have won multiple international accolades from <strong>Cannes Lion, Favourite Website Awards, Creative Circle, Spikes Asia, OneShow and
          Webby</strong>.
        </p>
        <p className="resume-description">
          In my free time, I am also a contributor for <strong>UX Planet</strong> and <strong>HackerNoon</strong> - both online publications on Medium with millions of
          viewership, where I share my learnings in product building, engineering and design thinking case studies.
        </p>
        <p className="resume-description">
          I've judged for <strong>The Crowbar Awards</strong> as a jury for the interactive category. I graduated
          from Queensland University of Technology, and when I'm not coding or burning something down with my soldering iron, I will be
          jamming with my bandmates, collecting vinyl records or running a marathon.
        </p>
      </section>

      {/* Copy Email Link */}
      <div className="contact-inline">
        Get in touch: 
        <button onClick={handleCopyEmail} className="btn-copy-email">
          chanwaihsuen@gmail.com
        </button>
        {copied && <span className="copied-indicator">[copied]</span>}
      </div>

      {/* Expose Full Social Links */}
      <section style={{ marginTop: '3rem' }}>
        <h3 style={{ fontSize: '0.75rem', fontWeight: 800, letterSpacing: '0.12em', color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: '1.25rem' }}>
          Connect
        </h3>
        <ul className="social-list-vertical">
          {SOCIAL_LINKS.map((link) => (
            <li key={link.label} className="social-vertical-item">
              <span className="social-item-label">{link.label}</span>
              <a target="_blank" rel="noopener noreferrer" href={link.url} className="social-item-url">
                {link.url}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default Resume;
